import { router } from "@inertiajs/react"
import { useEffect, useRef, useState } from "react"

import { adminEmailHealthPath } from "@/routes"

/**
 * dry_run is deliberately absent: a partial visit that omits it preserves the
 * verdict card across refreshes.
 */
const REFRESH_PROPS = ["report", "ledger_messages", "recent_events", "triggers"]
const INTERVAL_MS = 30_000

/**
 * Opt-in polling for watching the oldest-stuck age move. Visits the canonical
 * path explicitly rather than reloading the current URL — after a dry-run
 * POST the page URL is the POST-only /dry_run path, and a Re-check DNS visit
 * leaves ?refresh_dns=1 behind; reloading either would break the partial or
 * re-bust the DNS cache every tick. Ticks skip while the tab is hidden.
 */
export function useAutoRefresh() {
  const [enabled, setEnabled] = useState(false)
  const [refreshing, setRefreshing] = useState(false)
  const [lastRefreshedAt, setLastRefreshedAt] = useState<Date | null>(null)
  const inFlight = useRef(false)

  useEffect(() => {
    if (!enabled) return undefined

    const tick = () => {
      if (document.hidden || inFlight.current) return
      inFlight.current = true
      router.visit(adminEmailHealthPath(), {
        only: REFRESH_PROPS,
        preserveScroll: true,
        preserveState: true,
        onStart: () => setRefreshing(true),
        onFinish: () => {
          inFlight.current = false
          setRefreshing(false)
          setLastRefreshedAt(new Date())
        },
      })
    }

    const id = window.setInterval(tick, INTERVAL_MS)
    return () => window.clearInterval(id)
  }, [enabled])

  return { enabled, setEnabled, refreshing, lastRefreshedAt }
}
